import React from 'react';
import { useQuery } from '@apollo/client';
import NotificacionIcon from './NotificacionIcon';
import { OBTENER_TOTAL_NUM_NOTIFICACIONES } from '../../../graphql/queries/notificaciones';

const Notificaciones = () => {
  const { data, loading, refetch } = useQuery(OBTENER_TOTAL_NUM_NOTIFICACIONES, { variables: { activo: true }, fetchPolicy: 'no-cache' });

  if (loading) return null;

  const totalItems = data.notificaciones.obtenerNumNotificaciones;

  return <NotificacionIcon totalItems={totalItems} refetch={refetch}/>;
};

export default Notificaciones;
